import { Controller } from 'react-hook-form'

import { FormsLayout } from 'components/Layout/Forms'
import Button from 'components/Button'
import { VouchersDataTypes } from 'types/vouchers'

import Dropdown from 'components/Dropdown'
import { useMemberVouchersStatusUpdate } from './useMemberVouchersStatusUpdate'
import { useMemberVouchersStatusUpdateForm } from './useMemberVouchersStatusUpdateForm'
import { useMemberVouchersStatuses } from './useMemberVouchersStatuses'

const Index = ({
  modalClose,
  selectedRowData,
}: {
  modalClose: () => void
  selectedRowData: VouchersDataTypes
}): JSX.Element => {
  const {
    memberVouchersStatusesOptions,
    memberVouchersStatusesModStatus,
  } = useMemberVouchersStatuses({ voucherCurrentStatus: selectedRowData.status })

  const {
    memberVouchersStatusUpdateParams,
    memberHandleVouchersStatusUpdate,
  } = useMemberVouchersStatusUpdate({
    modalClose,
    selectedRowData,
  })

  const { control, handleSubmit, setValue, watch } =
    useMemberVouchersStatusUpdateForm({
      defaultValues: memberVouchersStatusUpdateParams,
    })

  const isLoading =
    memberVouchersStatusesModStatus !== 'success' ? true : false

  if (isLoading) return <></>

  if (memberVouchersStatusesOptions.length === 0) {
    return (
      <div className="p-6 text-center">
        <p>
          This voucher cannot be updated. Only active vouchers can be cancelled.
        </p>
      </div>
    )
  }

  return (
    <FormsLayout.Wrapper
      onSubmit={handleSubmit(memberHandleVouchersStatusUpdate)}
    >
      <FormsLayout.Item>
        <Controller
          name="voucherStatusId"
          control={control}
          render={({ field }) => (
            <Dropdown
              title="To Status"
              defaultValue={
                memberVouchersStatusesOptions.filter(
                  (item) =>
                    parseInt(item.value) ===
                    memberVouchersStatusUpdateParams.voucherStatusId
                )[0]
              }
              options={memberVouchersStatusesOptions}
              className="w-full menu-outer-top tracking-wider"
              borderColor="#C4C4C4"
              onSelect={(value) => {
                setValue('voucherStatusId', parseInt(value.value))
              }}
              overflowStyle
            />
          )}
        />
      </FormsLayout.Item>

      <FormsLayout.ActionWrapper>
        <Button key="submit" type="submit" className="mr-2 rounded bg-primary">
          <span className="tracking-wider font-bold">Update status</span>
        </Button>
      </FormsLayout.ActionWrapper>
    </FormsLayout.Wrapper>
  )
}

export default Index
